export const routes = {
   home: '/',
   catalog: '/katalog/produkty/5',
   catalogModel: '/katalog/produkty',
   catalogProduct: '/katalog/produkty/:productId',
   priceList: '/cennik',
   priceListProduct: '/cennik/:priceItemId',
   signIn: '/zaloguj',
   catalogConsent: '/katalog-zgoda'
};
